/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ClothesShoesSneakersIcon24Solid = forwardRef('ClothesShoesSneakersIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.25 4.817c0-.893.99-1.43 1.739-.943l3.755 2.445-1.662 2.519a.75.75 0 1 0 1.252.826l1.668-2.527 1.837 1.196-1.601 2.379a.75.75 0 0 0 1.244.837l1.614-2.398 2.518 1.64A5.25 5.25 0 0 1 22.997 15H1V7.196c0-1.042 1.296-1.524 1.977-.735.749.868 1.447 1.789 2.715 1.789A2.558 2.558 0 0 0 8.25 5.692v-.875Z" }),
        React.createElement("path", { d: "M1 16.5v1.25A2.25 2.25 0 0 0 3.25 20h17.5A2.25 2.25 0 0 0 23 17.75V16.5H1Z" })));
});
